if (!customElements.get('option-modal')) {
    customElements.define(
      'option-modal',
      class OptionModal extends ModalDialog {
        constructor() {
          super();
          this.button = document.querySelector(`.${this.id}`);
          this.button.addEventListener('click', this.handleClick.bind(this))
        }
  
        hide() {
          super.hide();
        }
  
        handleClick() {
            super.show(this.button);
        }
      }
    );
}
